module.exports = __webpack_public_path__ + "img/homepage_6.db763db0.png";